<template>
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">{{title}}</h5>
    </div>
    <div class="card-body d-flex align-items-center">
      <table class="w-100">
        <tr>
          <td style="width: 40%"><b>{{$t('Balance')}}</b></td>
          <td>{{balanceInfo.balance}}</td>
        </tr>
        <tr>
          <td><b>{{$t('Available')}}</b></td>
          <td>{{balanceInfo.available_balance}}</td>
        </tr>
        <tr>
          <td><b>{{$t('Blocked')}}</b></td>
          <td>{{balanceInfo.blocked}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import i18n from "../../../../shared/i18n";

  export default {
    name: "BalanceViewCard",
    props: {
      customer: {
        type: Object,
        required: true
      },
      title: {
        type: String,
        default: i18n.t('Balance')
      }
    },
    computed: {
      balanceInfo() {
        if (!this.customer || !this.customer.deposits || this.customer.deposits.length === 0) {
          return {
            balance: this.$options.filters.asCurrency(0),
            available_balance: this.$options.filters.asCurrency(0),
            blocked: this.$options.filters.asCurrency(0),
          }
        }

        let balance = [];
        let available_balance = [];
        let blocked = [];

        for (let deposit of this.customer.deposits) {
          balance.push(this.$options.filters.asCurrency(deposit.balance, deposit.currency.symbol));
          available_balance.push(this.$options.filters.asCurrency(deposit.available_balance, deposit.currency.symbol));
          blocked.push(this.$options.filters.asCurrency(deposit.blocked, deposit.currency.symbol));
        }

        return {
          balance: balance.join(' / '),
          available_balance: available_balance.join(' / '),
          blocked: blocked.join(' / ')
        }
      }
    }
  }
</script>

<style scoped>

</style>
